import React from 'react'
import Badge from '~/components/atoms/Badge'

function PrivateBadge() {
  return <Badge>公開停止中</Badge>
}

export default PrivateBadge
